import React from 'react';
import Icon from '../../../components/AppIcon';

const PayrollMappingEngine = ({ connection }) => {
  const mappingScenarios = [
    {
      category: 'NASFUND Contributions',
      description: 'Employee and employer superannuation contributions',
      fields: [
        { hr: 'employee_super', erp: 'nasfund_employee', rate: '6%' },
        { hr: 'employer_super', erp: 'nasfund_employer', rate: '8.4%' }
      ]
    },
    {
      category: 'SWT Calculations',
      description: 'Salary and Wages Tax withholding',
      fields: [
        { hr: 'swt_amount', erp: 'tax_withheld', calculation: 'Progressive tax brackets' },
        { hr: 'taxable_income', erp: 'gross_taxable', calculation: 'Gross - Deductions' }
      ]
    },
    {
      category: 'Overtime Rates',
      description: 'Overtime and Sunday work calculations',
      fields: [
        { hr: 'overtime_pay', erp: 'ot_earnings', rate: '1.5x regular rate' },
        { hr: 'sunday_pay', erp: 'sunday_earnings', rate: '2x regular rate' }
      ]
    },
    {
      category: 'Leave Accruals',
      description: 'Annual and sick leave entitlements',
      fields: [
        { hr: 'annual_leave_balance', erp: 'leave_annual', accrual: '4 weeks per year' },
        { hr: 'sick_leave_balance', erp: 'leave_sick', accrual: '2 weeks per year' }
      ]
    }
  ];

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-foreground">Payroll Mapping Engine</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Complex payroll scenarios with PNG Employment Act compliance and automatic PGK formatting
        </p>
      </div>

      <div className="space-y-6">
        {mappingScenarios?.map((scenario, index) => (
          <div key={index} className="bg-background border border-border rounded-lg p-5">
            <div className="flex items-start justify-between mb-4">
              <div>
                <h3 className="text-lg font-semibold text-foreground">{scenario?.category}</h3>
                <p className="text-sm text-muted-foreground mt-1">{scenario?.description}</p>
              </div>
              <span className="px-3 py-1 bg-success/10 text-success rounded text-xs font-medium">
                Active
              </span>
            </div>

            <div className="space-y-3">
              {scenario?.fields?.map((field, fieldIndex) => (
                <div key={fieldIndex} className="flex items-center gap-4 p-3 bg-card border border-border rounded-lg">
                  <div className="flex-1">
                    <div className="flex items-center gap-3">
                      <div className="flex-1">
                        <div className="text-sm font-medium text-foreground">{field?.hr}</div>
                        <div className="text-xs text-muted-foreground">HR System</div>
                      </div>
                      <Icon name="ArrowRight" size={20} className="text-muted-foreground" />
                      <div className="flex-1">
                        <div className="text-sm font-medium text-foreground">{field?.erp}</div>
                        <div className="text-xs text-muted-foreground">ERP System</div>
                      </div>
                    </div>
                  </div>
                  <div className="px-4 py-2 bg-primary/10 text-primary rounded text-sm font-medium">
                    {field?.rate || field?.calculation || field?.accrual}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PayrollMappingEngine;
